import React from "react";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import { useAuthContext } from "@stores/AuthContext";
import { useOptionalPlansBillingContext } from "@stores/PlansBillingContext";
import { Coins, LogOutV2, Play } from "@piiqtechnologies/svg-icons";
import { PeekBox, PeekDivider, PeekPaper, PeekStack } from "@piiqtechnologies/ui-components";
import { NavigationCommunityItem, NavigationListItem, NavigationLogo, NavigationTitle, } from "./components";
import { PATHS } from "@constants/Paths";
import { useBillingEnabled } from "@hooks";
import { setTutorialActive } from "@utils/tutorial";
import messages from "./messages.i18n";
export const NavigationBar = ({ title, titleUpperCase = true, headerContent, communityNavigationItem, showDivider = true, scrollableContent = false, onReplayTour, children, }) => {
    var _a, _b;
    const intl = useIntl();
    const navigate = useNavigate();
    const billingEnabled = useBillingEnabled();
    const plansBilling = useOptionalPlansBillingContext();
    const { onLogout, isDiscoverAdmin, user } = useAuthContext();
    const openPlansBilling = plansBilling === null || plansBilling === void 0 ? void 0 : plansBilling.openPlansBilling;
    const closePlansBilling = plansBilling === null || plansBilling === void 0 ? void 0 : plansBilling.closePlansBilling;
    const isPlansBillingOpen = Boolean(plansBilling === null || plansBilling === void 0 ? void 0 : plansBilling.isPlansBillingOpen);
    const isPeekStaff = Boolean(((_a = user === null || user === void 0 ? void 0 : user.email) === null || _a === void 0 ? void 0 : _a.toLowerCase().endsWith("@peek.us")) && !((_b = user === null || user === void 0 ? void 0 : user.email) === null || _b === void 0 ? void 0 : _b.includes("+")));
    const canAccessPlansBilling = billingEnabled && isDiscoverAdmin && !isPeekStaff;
    const handleLogout = () => {
        onLogout();
        navigate(PATHS.LOGIN, { replace: true });
    };
    const handleReplayTour = () => {
        navigate(PATHS.HOME);
        setTutorialActive();
        onReplayTour === null || onReplayTour === void 0 ? void 0 : onReplayTour();
    };
    return (React.createElement(PeekPaper, { elevation: 0, sx: {
            top: 0,
            width: 170,
            height: "100%",
            position: "sticky",
        } },
        React.createElement(PeekStack, { sx: { px: 1, py: 2, overflow: "hidden" }, height: "-webkit-fill-available", justifyContent: "space-between" },
            React.createElement(PeekStack, { direction: "column", sx: { flex: 1, minHeight: 0 } },
                React.createElement(NavigationLogo, null),
                React.createElement(PeekStack, { gap: 1, mt: 3 },
                    React.createElement(NavigationTitle, { isUpperCase: titleUpperCase, content: title !== null && title !== void 0 ? title : intl.formatMessage(messages.reportNavigationTitle) }),
                    communityNavigationItem ? React.createElement(NavigationCommunityItem, { community: communityNavigationItem }) : null,
                    headerContent),
                React.createElement(PeekStack, { direction: "row", width: "100%", gap: 1, sx: scrollableContent ? { flex: 1, minHeight: 0 } : undefined },
                    showDivider && React.createElement(PeekDivider, { light: true, orientation: "vertical", sx: { height: "auto" } }),
                    React.createElement(PeekStack, { gap: 2, width: "100%", mt: 2, pr: 1, sx: scrollableContent
                            ? {
                                flex: 1,
                                minHeight: 0,
                                overflowY: "auto",
                                scrollbarWidth: "thin",
                            }
                            : undefined, onClick: isPlansBillingOpen ? closePlansBilling : undefined }, children))),
            React.createElement(PeekStack, { gap: 1 },
                React.createElement(PeekDivider, { orientation: "horizontal", light: true }),
                React.createElement(PeekBox, { sx: { ml: 1 } },
                    onReplayTour && (React.createElement(NavigationListItem, { onClick: handleReplayTour, icon: React.createElement(Play, { width: 12 }), label: intl.formatMessage(messages.aiDiscoverabilityDashboardReplayTour) })),
                    canAccessPlansBilling && openPlansBilling && (React.createElement(NavigationListItem, { onClick: openPlansBilling, icon: React.createElement(Coins, { width: 15, height: 15 }), forceActive: true, isActive: isPlansBillingOpen, label: intl.formatMessage(messages.aiDiscoverabilityDashboardPlansBilling) })),
                    React.createElement(NavigationListItem, { onClick: handleLogout, icon: React.createElement(LogOutV2, null), label: intl.formatMessage(messages.aiDiscoverabilityDashboardLogout) }))))));
};
export default NavigationBar;
